import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class DataSource<T = any, R = any> {
  data: R[] = [];
  totalPages: number = 1;

  private readonly _resultProperty: keyof T;
  private readonly _totalPagesProperty:  keyof T;

  constructor(resultProperty: keyof T, totalPagesProperty: keyof T) {
    this._resultProperty = resultProperty;
    this._totalPagesProperty = totalPagesProperty;
  }

  query(query$: Observable<T>): Observable<R[]> {
    return query$.pipe(
      map((queryResult: T) =>  {
        this.totalPages = queryResult[this._totalPagesProperty] as number;
        this.data = [...this.data, ...queryResult[this._resultProperty] as R[]];
        return this.data;
      }),
    );
  }

  reset(): void  {
    this.totalPages = 1;
    this.data = [];
  }
}
